var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCnfIcon2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26747_26066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8327L8.83616 11.9016C9.25403 12.2359 9.86103 12.182 10.2134 11.7792L12.5 9.16602",
    stroke: "#181D27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 10.834,
    rx: 7.5,
    ry: 7.5,
    stroke: "#181D27",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0027 1.66602C15.7723 2.43986 17.2747 3.71112 18.3332 5.30302M5.99699 1.66602C4.22736 2.43986 2.72494 3.71112 1.6665 5.30302",
    stroke: "#181D27",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.334L15.6309 15.834M2.5 18.334L4.36893 15.834",
    stroke: "#181D27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26747_26066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCnfIcon2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cnfIcon2.a9489d0561a992222c94749d43b181ea.svg";